import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-47cb0c8d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "report"
};
const _hoisted_2 = {
  class: "panel"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "报表查询")], -1));

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  class: "xunitable"
};
const _hoisted_6 = {
  class: "myform"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("下注类型：");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("用户名：");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("报表类型：");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("交收报表");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("分类报表");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("结算状态：");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("已结算");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("未结算");

const _hoisted_15 = {
  class: "sub"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode("发送报表");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_datepicker = _resolveComponent("datepicker");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_button = _resolveComponent("el-button");

  const _component_jiaoshou = _resolveComponent("jiaoshou");

  const _component_fenlei = _resolveComponent("fenlei");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
    class: "report-form",
    style: _normalizeStyle({
      width: $data.width
    })
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
    ref: "tableRef",
    data: $data.xunitabledata,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "show-summary": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "username",
      align: "center",
      label: "级别",
      "min-width": "60px"
    }), _createVNode(_component_el_table_column, {
      prop: "real_name",
      label: "名称",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "bet_count",
      label: "笔数",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "sum_bet",
      label: "总投注额",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "balance",
      label: "有效金额",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "hy_shuyin",
      label: "会员输赢",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "receive_subline",
      label: "应收下线",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "sup_occupy_lock",
      label: "实占成数",
      align: "center",
      width: "60"
    }), _createVNode(_component_el_table_column, {
      prop: "occu_balance",
      label: "实占注额",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "bonus",
      label: "占货比",
      align: "center",
      width: "47"
    }), _createVNode(_component_el_table_column, {
      prop: "occu_winlose",
      label: "实占输赢",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "occu_rebate",
      label: "实占退水",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "real_occupy_result",
      label: "实占结果",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "earn_rebate",
      label: "赚取退水",
      align: "center"
    }), _ctx.$store.state.userinfo.group_id == 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      prop: "eran",
      label: "赚取赔差",
      align: "center",
      width: "60"
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "real_result",
      label: "退水后结果",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "cont_sup",
      label: "贡献上级",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "receive_supline",
      label: "应付上级",
      align: "center"
    })]),
    _: 1
  }, 8, ["data"])]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 4
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.game_class_checked,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.game_class_checked = $event),
        size: "small",
        style: {
          "width": "140px"
        },
        onChange: $options.select_class
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_class, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.name,
            label: item.label,
            value: item.name
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"]), _withDirectives(_createElementVNode("span", null, [_createVNode(_component_el_select, {
        modelValue: $data.form.gid,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.gid = $event),
        size: "small",
        style: {
          "width": "140px",
          "margin": "0 6px"
        },
        onChange: $options.select_one_game
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.kc_game_list, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.gname,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])], 512), [[_vShow, $data.game_class_checked == 'kc']]), _withDirectives(_createElementVNode("span", null, [_createVNode(_component_el_select, {
        modelValue: $data.form.gid,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.gid = $event),
        size: "small",
        style: {
          "width": "140px",
          "margin": "0 6px"
        },
        onChange: $options.select_one_game
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.lhc_game_list, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.gname,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])], 512), [[_vShow, $data.game_class_checked == 'lhc']]), _withDirectives(_createElementVNode("span", null, [_createVNode(_component_el_select, {
        modelValue: $data.form.game_play,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.game_play = $event),
        size: "small",
        style: {
          "width": "140px"
        },
        onChange: $options.select_game_play
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_play_list, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.name,
            label: item.name,
            value: item.name
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])], 512), [[_vShow, $data.form.game_play != '']])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 4
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.username,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.username = $event),
        placeholder: "查找用户名",
        clearable: "",
        size: "small",
        style: {
          "width": "140px"
        },
        onChange: $options.get_report_wait
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 4
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        modelValue: $data.date_or_qnum,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.date_or_qnum = $event),
        label: "按期数：",
        onChange: $options.select_qnum
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.qid,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.qid = $event),
        size: "small",
        style: {
          "width": "200px"
        },
        onChange: $options.select_game_play,
        placeholder: "--- 请选择 ---"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.qnum_list, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.gid,
            label: item.gname + '-' + item.qnum,
            value: item.qnum
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 4
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        modelValue: $data.date_or_qnum,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.date_or_qnum = $event),
        label: "按日期：",
        onChange: $options.select_qnum
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 20,
      style: {
        "padding": "3px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_datepicker, {
        ref: "datePicker",
        from: "报表查询",
        onGetDate: $options.getDate,
        showBtns: true,
        onlyUpdate: $data.onlyUpdate
      }, null, 8, ["onGetDate", "onlyUpdate"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 4
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.report_type,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.report_type = $event),
        onChange: $options.get_report_wait
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "交收报表"
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "分类报表"
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 4
    }, {
      default: _withCtx(() => [_hoisted_12]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.settle_state,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.settle_state = $event),
        onChange: $options.get_report_wait
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 3
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 2
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  })], 512), [[_vShow, !$data.dialog.visible]])]), _withDirectives(_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
    size: "small",
    type: "warning",
    onClick: $options.get_report_btn_click
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btntext), 1)]),
    _: 1
  }, 8, ["onClick"]), _withDirectives(_createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.send_report
  }, {
    default: _withCtx(() => [_hoisted_16]),
    _: 1
  }, 8, ["onClick"]), [[_vShow, _ctx.$store.state.userinfo.user_id == 1]])], 512), [[_vShow, !$data.dialog.visible]])])], 4), [[_vShow, !$data.dialog.visible]]), _withDirectives(_createElementVNode("div", null, [_withDirectives(_createVNode(_component_jiaoshou, {
    ref: "jiaoshou",
    bbdata: $data.bbdata,
    search_title_info: $data.search_title_info,
    form: $data.form,
    group_id: $data.group_id,
    show_waibu: $data.show_waibu,
    bh_cs: $data.game_detail_total.post,
    game_list: $data.game_list,
    onChange_page: $options.change_page_js,
    onSearch_username: $options.get_report,
    onSearch_sub: $options.search_sub,
    onGet_game_detail: $options.get_game_detail,
    onBack_search: $options.dialog_close
  }, null, 8, ["bbdata", "search_title_info", "form", "group_id", "show_waibu", "bh_cs", "game_list", "onChange_page", "onSearch_username", "onSearch_sub", "onGet_game_detail", "onBack_search"]), [[_vShow, $data.form.report_type == '交收报表']]), _withDirectives(_createVNode(_component_fenlei, {
    ref: "fenlei",
    bbdata: $data.bbdata,
    onChange_page: $options.change_page_fl,
    form: $data.form,
    search_title_info: $data.search_title_info,
    onBack_search: $options.dialog_close,
    onSearch_paly: $options.search_paly
  }, null, 8, ["bbdata", "onChange_page", "form", "search_title_info", "onBack_search", "onSearch_paly"]), [[_vShow, $data.form.report_type == '分类报表']])], 512), [[_vShow, $data.dialog.visible]])]);
}